import { render } from "./RestaurantCategory.vue?vue&type=template&id=4b9d8339&scoped=true"
import script from "./RestaurantCategory.vue?vue&type=script&lang=js"
export * from "./RestaurantCategory.vue?vue&type=script&lang=js"

import "./RestaurantCategory.vue?vue&type=style&index=0&id=4b9d8339&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b9d8339"]])

export default __exports__